import api from 'api'
import { AxiosRequestConfig } from 'axios'

export const authenticateUser = async (
  email: string,
  password: string,
  otp?: string
): Promise<UserAuth | { otp: boolean }> => {
  const result = await api.post<UserAuth>('/auth/basic', { otp }, { auth: { username: email, password } })
  return result.data
}

export const getUserInfo = async (options?: AxiosRequestConfig): Promise<UserInfo> => {
  const result = await api.get<UserInfo>('/userInfo', options)
  return result.data
}
